import type { App, Component } from 'vue'
import { defineAsyncComponent } from 'vue'

export default {
  install(app: App<Element>) {
    const components: Record<string, () => Promise<Component>> = import.meta.glob('./*/index.vue')
    for (const [key, value] of Object.entries(components)) {
      const name = `m-${key.replace('./', '').split('/')[0]}`
      app.component(name, defineAsyncComponent(value))
    }
  },
}
